import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess123010Status: 'idle',
    startProcess123010Error: undefined as any,
    loadUserParamsProcess123010Status: 'idle',
    loadUserParamsProcess123010Error: undefined as any,

    process123010List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess123010 = createAsyncThunk('process123010Slice/startProcess123010', async ({ process123010 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess123010/`,
        prepareData(process123010),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess123010Status } = getState().process123010Slice
        return startProcess123010Status !== 'pending'
    }
})

export const loadUserParamsProcess123010 = createAsyncThunk('process123010Slice/loadUserParamsProcess123010', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess123010/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess123010Status } = getState().process123010Slice
        return loadUserParamsProcess123010Status !== 'pending'
    }
})

const Process123010Slice = createSlice({
    name: 'process123010Slice',
    initialState,
    reducers: {
        resetstartProcess123010: (state) => {
            state.job = undefined
            state.startProcess123010Error = undefined
        },
        resetstartProcess123010Error: (state) => {
            state.startProcess123010Error = undefined
        },
        resetloadUserParamsProcess123010: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess123010Error = undefined
        },
        resetloadUserParamsProcess123010Error: (state) => {
            state.loadUserParamsProcess123010Error = undefined
        },
        removeFromProcess123010ListById: (state, action) => {
            state.process123010List = state.process123010List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess123010ListByIds: (state, action) => {
            state.process123010List = state.process123010List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process123010List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess123010Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process123010List = []
            state.startProcess123010Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess123010.pending, (state) => {
            state.startProcess123010Status = 'pending'
            state.startProcess123010Error = undefined
        })
        builder.addCase(startProcess123010.fulfilled, (state, action) => {
            state.startProcess123010Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess123010.rejected, (state, action) => {
            state.startProcess123010Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess123010Error = action.error.message
            } else {
                state.startProcess123010Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess123010.pending, (state) => {
            state.loadUserParamsProcess123010Status = 'pending'
            state.loadUserParamsProcess123010Error = undefined
        })
        builder.addCase(loadUserParamsProcess123010.fulfilled, (state, action) => {
            state.loadUserParamsProcess123010Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess123010.rejected, (state, action) => {
            state.loadUserParamsProcess123010Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess123010Error = action.error.message
            } else {
                state.loadUserParamsProcess123010Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess123010,
    resetstartProcess123010Error,
    resetloadUserParamsProcess123010,
    resetloadUserParamsProcess123010Error,
    removeFromProcess123010ListById,
    removeFromProcess123010ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process123010Slice.actions
export default Process123010Slice.reducer
